import { CreateItemGqlError, CreateItemGqlStatus } from '../../../../types';
import { CreateInvoiceCustomFieldCacheKeys } from '../../invoiceCustomFieldsTypes';

import { CACHE_CREATE_INVOICE_CUSTOM_FIELD_QUERY } from '../../queries/cacheCreateInvoiceCustomField.query';

import { useCacheCreateQuery } from '../../../common/reactQuery/hooks/useCacheCreateQuery';

interface CacheCreateInvoiceCustomFieldOptions {
  cacheKeys?: CreateInvoiceCustomFieldCacheKeys;
}

export interface CacheCreateInvoiceCustomFieldInput {
  invoiceUuid: string;
  label: string;
  body?: string;
  location: string;
  order?: number;
  options?: Record<string, any>;
}

export interface CacheCreateInvoiceCustomFieldRecord {
  body?: string;
  createdAt: string;
  id: string;
  invoiceId: string;
  label: string;
  location: string;
  type: string;
  updatedAt: string;
  userId: string;
  uuid: string;
}

export interface CacheCreateInvoiceCustomFieldResponse {
  createInvoiceCustomField: {
    status: CreateItemGqlStatus;
    record: CacheCreateInvoiceCustomFieldRecord;
    errors: CreateItemGqlError;
    recordId: string;
    recordNanoId?: string;
    recordUuid?: string;
  };
}

export interface CacheCreateInvoiceCustomFieldError {
  fullMessages: string[];
}

const action = 'createInvoiceCustomField';

function useCacheCreateInvoiceCustomField({
  cacheKeys
}: CacheCreateInvoiceCustomFieldOptions = {}) {
  const {
    createCacheQuery,
    createCacheQueryData,
    createCacheQueryError,
    createCacheQueryErrorMessage,
    createCacheQueryLoading,
    createCacheQueryReset
  } = useCacheCreateQuery<
    CacheCreateInvoiceCustomFieldInput,
    CacheCreateInvoiceCustomFieldResponse,
    CacheCreateInvoiceCustomFieldError,
    CacheCreateInvoiceCustomFieldRecord
  >({
    action,
    query: CACHE_CREATE_INVOICE_CUSTOM_FIELD_QUERY,
    cacheKeys
  });

  return {
    createInvoiceCustomField: createCacheQuery,
    createInvoiceCustomFieldData: createCacheQueryData,
    createInvoiceCustomFieldError: createCacheQueryError,
    createInvoiceCustomFieldErrorMessage: createCacheQueryErrorMessage,
    createInvoiceCustomFieldLoading: createCacheQueryLoading,
    createInvoiceCustomFieldReset: createCacheQueryReset
  };
}

export default useCacheCreateInvoiceCustomField;
